import React from 'react';
import Page from '../core/screens/Page';
import '../css/screens/UseCasePage.scss';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import { ArrowHalfDown } from '../ui/Vectors';
import ContentBuilder from '../core/ContentBuilder';

export default class UseCasePage extends Page {
	render() {
		console.log(this.props.content.banner.image.src)
		return this.wrap(
			<React.Fragment>
				<div className="header padding">
					<Grid cols={2} breakpoints={{small: {cols: 4}}}>
						<div className='title'>{this.props.content.title}</div>
						<div className='subtitle'>{this.props.content.subtitle}</div>
					</Grid>
					<Grid cols={2} breakpoints={{small: {cols: 4}}}>
						<div className='text'>{this.props.content.text}</div>
					</Grid>
				</div>
				<Grid cols={4} skip={0} className='banner flex-middle'>
					<Grid cols={3} skip={0} breakpoints={{small: {cols: 4}}} className="title">{this.props.content.banner.title}</Grid>
					<Grid cols={1} breakpoints={{small: {cols: 4}}} className='text'>{this.props.content.banner.description}</Grid>
					<Grid cols={4} className='image' style={{backgroundImage: 'url(' + this.props.content.banner.image.src + ')'}}>
					</Grid>
				</Grid>
				<Grid cols={4} className='items'>
					{
						this.props.content.items.map((c, i) => {
							console.log(c);
							return (<UseCaseItem key={i} content={c}></UseCaseItem>)
						})
					}
				</Grid>
			</React.Fragment>
		);
	}
}

class UseCaseItem extends React.Component<{content}>
{
	render()
	{
		return (
			<div className='item'>
				<Grid cols={4} className='hide-medium show-small'>
					<div className='subtitle'>{this.props.content.subtitle}</div>
				</Grid>
				<Grid cols={1} style={{position: 'relative'}} className="padding">
					<img className='thumb' {...this.props.content.image} />
				</Grid>
				<Grid cols={2} className="padding" breakpoints={{small: {cols: 3}}}>
					<Grid cols={4}>
						<div className='itemTitle'>{this.props.content.title}</div>
						<div className='content'>
							{ContentBuilder.build(this.props.content.content)}
						</div>
					</Grid>
				</Grid>
				<Grid cols={1} className='hide-small'>
					<div className='subtitle'>{this.props.content.subtitle}</div>
				</Grid>
			</div>
		);
	}
}
